declare var swal: any;
import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { ActorService } from '../../../../services/actor.service';
import { ActorProfileRequest, ActorProfileController, ActorImageController, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, GuardianInfoController, GuardianInfoRequest, SaveCustomerMessageRequest, CustomerMessageRequest, CustomerMessageController, OTFormDetailByReportCodeController, OTFormDetailByReportCodeRequest, SectionData, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, CycleOocyteQualityBetweenDateController, CycleOocyteQualityBetweenDateRequest, SaveSpermDetailsRequest, SpermSourceDetailsRequest, SpermSourceDetailsController, SaveSemenDataRequest, SaveIvfSpermStoreRequest, IvfSpermStoreByCodeController, IvfSpermStoreByCodeRequest, CycleSpermPreparationBetweenDateRequest, CycleSpermPreparationBetweenDateController, SaveCycleStatusRequest, TreatmentCycleStatusController, TreatmentCycleStatusRequest, DSAActivityByCycleCodeController, DSAActivityByCycleCodeRequest, FormOrganizer } from '../../../../models/actor/actor';
import { AppData } from '../../../../models/appdata';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { NgbdUploadActorImageModal } from '../../../../../modals/uploadactorimage/ngbuploadactorimage.modal';
import { ActorPersonalInfoController, ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController } from '../../../../models/profileinfo/profileinfo.model';
import { AppFeaturesList } from '../../../../constants/constants';
//import  './profilesteps.js';
import { HCPService } from '../../../../services/hcp.service';
declare var mess1: any;
declare var stepObject: any;
declare var pSteps: any;
declare var webGlObject: any;

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { routerTransition } from '../../../../animations/router.animations';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
//import { NgbTcDetailsModal } from '../tcdetails.modal';
//import { NgbEventAddModal } from './eventadd.modal';
import { FdActorReportsDocController, FDActorDocRequest } from '../../../../../../../src/app/ncs/models/formdesign/fd.model';
import { FDService } from '../../../../../../../src/app/ncs/services/fd.service';
import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';
import { NgbSearchDonarModal } from '../TreatmentCycle/searchdonar.modal';
import { SemanPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'ivfsemananedit',
  templateUrl: './ivfsemananedit.component.html',
  styleUrls: ['./ivfsemananedit.component.scss'],
  animations: [routerTransition()]
})

export class IvfSemananeditComponent implements OnInit, AfterViewInit {

  //Variable Declaration
  currentPage: string = "About"
  public isRequesting: boolean = false;
  CurrentActorProfileRequest: ActorProfileRequest;
  CurrentActorProfileController: ActorProfileController;
  //CurrentFdActorReportsDocController: FdActorReportsDocController[];
  //CurrentFDActorDocRequest: FDActorDocRequest;
  public ApiResData: ApiResponseModel;

  ValueChangeActorPersonalInfoController: ActorPersonalInfoController;
  ValueChangeActorImageController: ActorImageController;
  CurrentSaveSpermDetailsRequest: SaveSpermDetailsRequest;
  CurrentSaveSemenDataRequest: SaveSemenDataRequest;
  CurrentSaveIvfSpermStoreRequest: SaveIvfSpermStoreRequest;
  @Input() NurseActorCode: number = 0;
  @Input() ActorCode: number;
  @Input() CycleCode: number;
  @Input() Duration: number;
  @Input() FormattedCode: number;
  @Input() DisplayName: string;
  searchTitle: string;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  ExtractionDate: NgbDateStruct;
  DateofSampleCollection: NgbDateStruct;
  TodayDate = new Date();
  //
  //public FormattedCode: number = 0;
  public IsSetAccessRights: boolean;
  public CanEditProfileInfo: number = 0;
  public CanEditContactInfo: number = 0;
  public CanShowProfileInfo: number = 0;
  public CanShowContactInfo: number = 0;
  public Code: string;
  public PatientActorCode: number;
  public PatientCycleCode: number;
  public CanLoadReport: boolean = true;
  public CanShowProfileSummary: number = 0;
  public CanEditProfileSummary: number = 0;

  public CanShowJobPreferences: number = 0;
  public CanEditJobPreferences: number = 0;

  public CanShowEducation: number = 0;
  public CanEditEducation: number = 0;

  public CanShowEmploymentHistory: number = 0;
  public CanEditEmploymentHistory: number = 0;

  public CanShowReferences: number = 0;
  public CanEditReferences: number = 0;

  public CanShowIdentities: number = 0;
  public CanEditIdentities: number = 0;

  public CanShowCertifications: number = 0;
  public CanEditCertifications: number = 0;

  public CanShowMedicalFitness: number = 0;
  public CanEditMedicalFitness: number = 0;

  public CanShowProfileImage: number = 0;
  public CanEditProfileImage: number = 0;

  public CanShowLegalinfo: number = 0;
  public CanEditLegalinfo: number = 0;
  public showprofile: boolean = true;
  public showmessages: boolean = false;
  public ScanDetails: boolean = false;
  public ShowSemen: boolean = true;
  public Showivf: boolean = false;
  //
  CurrentSaveCycleStatusRequest: SaveCycleStatusRequest;

  CurrentFdActorReportsDocController: FdActorReportsDocController[];
  CurrentFDActorDocRequest: FDActorDocRequest;

  LoadForms() {
    this.CurrentFDActorDocRequest = new FDActorDocRequest();
    this.CurrentFdActorReportsDocController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentFDActorDocRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetFdActorReportsDocController();
  }
  public SelectedReport: string;
  public SelectedActorCode: number;
  GetFdActorReportsDocController() {
    this.StartRefreshing();

    this.CurrentFDActorDocRequest.ActorCode = 92;
    //this.CurrentFDActorDocRequest.ActorReportCode = null;
    //this.CurrentFDActorDocRequest.ActorReportTemplateCode = null;
    this.CurrentFDActorDocRequest.CreatedUserName = AppData.Instance().UserLoginDetails.DisplayName;
    this.CurrentFDActorDocRequest.ConditionalOperator = 11;
    //alert(this.FormattedCode);
    this.fdservice.GetFdActorReportsDocController(this.CurrentFDActorDocRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentFdActorReportsDocController = this.ApiResData.Result;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }



  CurrentCycleSpermPreparationBetweenDateController: CycleSpermPreparationBetweenDateController[];
  CurrentCycleSpermPreparationBetweenDateRequest: CycleSpermPreparationBetweenDateRequest;
  LoadPatients2() {
    this.CurrentCycleSpermPreparationBetweenDateRequest = new CycleSpermPreparationBetweenDateRequest();

    this.CurrentCycleSpermPreparationBetweenDateRequest.FacilityCode = AppData.Instance().SelectedBranchCode;

    this.CurrentCycleSpermPreparationBetweenDateRequest.ConditionalOperator = 10;


    this.CurrentCycleSpermPreparationBetweenDateRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.pdata = this.CurrentCycleSpermPreparationBetweenDateController;
    this.GetCycleSpermPreparationBetweenDateController();
  }

  GetCycleSpermPreparationBetweenDateController() {
    this.StartRefreshing();
    this.CurrentCycleSpermPreparationBetweenDateRequest.FromDate = new Date();
    this.CurrentCycleSpermPreparationBetweenDateRequest.ToDate = new Date();

    this.actorservice.GetCycleSpermPreparationBetweenDateController(this.CurrentCycleSpermPreparationBetweenDateRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentCycleSpermPreparationBetweenDateController = this.ApiResData.Result;
          this.pdata = this.CurrentCycleSpermPreparationBetweenDateController;

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  //CurrentCycleOocyteQualityBetweenDateController: CycleOocyteQualityBetweenDateController[];
  //CurrentCycleOocyteQualityBetweenDateRequest: CycleOocyteQualityBetweenDateRequest;
  //LoadPatients2() {
  //  this.CurrentCycleOocyteQualityBetweenDateRequest = new CycleOocyteQualityBetweenDateRequest();

  //  this.CurrentCycleOocyteQualityBetweenDateRequest.FacilityCode = AppData.Instance().UserLoginDetails.EmpFacilityCode;

  //  this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;


  //  this.CurrentCycleOocyteQualityBetweenDateRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
  //  this.GetCycleOocyteQualityBetweenDateController();
  //}

  //GetCycleOocyteQualityBetweenDateController() {
  //  this.StartRefreshing();
  //    this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
  //    this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();

  //  this.actorservice.GetCycleOocyteQualityBetweenDateController(this.CurrentCycleOocyteQualityBetweenDateRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        this.CurrentCycleOocyteQualityBetweenDateController = this.ApiResData.Result;
  //        this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;

  //        this.stopRefreshing();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();



  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();
  //        }
  //      }


  //    );
  //}
  constructor(private router: Router,
    public printService: PrintService, private spinner: NgxSpinnerService,
    private route: ActivatedRoute, private loaderService: SpinnerService, private parserFormatter: NgbDateParserFormatter, private actorservice: ActorService, private hcpservice: HCPService, private fdservice: FDService, private tosterservice: NGXToastrService,
    private modalService: NgbModal, private filter: SemanPipe) {

    //stepObject.init();
    //webGlObject.init();
  }


  ngOnInit() {

    $.getScript('./healins-assets/js/jquery.steps.js');
    $.getScript('./healins-assets/js/profilesteps.js');
    this.CurrentFDActorDocRequest = new FDActorDocRequest();
    ///////////////////////
    //this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.LoadForms();
    this.LoadPatients2();
    this.CurrentSaveSpermDetailsRequest = new SaveSpermDetailsRequest();
    this.CurrentSaveSpermDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveSemenDataRequest = new SaveSemenDataRequest();
    this.CurrentSaveSemenDataRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveIvfSpermStoreRequest = new SaveIvfSpermStoreRequest();
    this.CurrentSaveIvfSpermStoreRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveCycleStatusRequest = new SaveCycleStatusRequest();
    this.CurrentSaveCycleStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.LoadPatients();
    ///this.LoadClinics();
    //this.LoadMessages();
    this.PatientActorCode = this.ActorCode;
    this.PatientCycleCode = this.CycleCode;

    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.onSetFeatureAccessConfig();

    this.CurrentActorProfileRequest = new ActorProfileRequest();
    this.CurrentActorProfileController = new ActorProfileController();
    if (this.NurseActorCode > 0) {
      this.CurrentActorProfileRequest.ActorCode = this.NurseActorCode;
    }
    else {
      this.CurrentActorProfileRequest.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    }
    this.CurrentActorProfileRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.ValueChangeActorPersonalInfoController = new ActorPersonalInfoController();
    this.ValueChangeActorImageController = new ActorImageController();
    // Horizontal Timeline js for user timeline
    //$.getScript('./assets/js/vertical-timeline.js');
    //



  }
  public viewmode: string = 'view';
  public fo: FormOrganizer;

  SetForm() {

    this.fo = new FormOrganizer();

    this.fo.Sections = new Array<SectionData>();
    var i = 0;
    while (i < this.FormData.length) {
      this.fo.Sections.push(this.FormData[i]);
      i++;
    }
    this.fo.Organize();
    //this.spinner.hide();
  }
  FormData: SectionData[];
  CurrentOTFormDetailByReportCodeController: OTFormDetailByReportCodeController[];
  CurrentOTFormDetailByReportCodeRequest: OTFormDetailByReportCodeRequest;
  LoadClinics(reportCode: string) {

    var r1: OTFormDetailByReportCodeRequest = new OTFormDetailByReportCodeRequest();
    r1.ConditionalOperator = 10;

    r1.PatientReportCode = this.Code;
    r1.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.GetOTFormDetailByReportCodeController(r1).subscribe
      ((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.stopRefreshing();
          //  this.CurrentOTFormDetailByReportCodeController = this.ApiResData.Result;
          //alert(this.CurrentOTFormDetailByReportCodeController);
          // var reportCode: number = this.CurrentOTFormsByFormattedCodeController[0].PatientReportCode;
          this.FormData = this.ApiResData.Result;
          this.SetForm();
          //if (this.FormData.length > 0)
          //  alert(this.FormData[0].Title);
          //else {
          //  alert("no data retrieved");
          //}



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }



  onAssignedToActorCode(event: any) {

    if (event != null) {
      //alert(this.SelectedReport);
      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      //this.CurrentFdActorReportsDocController[0].TemplateName = event;
      // console.log('event--_>' + event);
      //   }
      this.Code = this.SelectedReport;
      this.LoadClinics(this.Code);
    }

  }

  ngAfterViewInit() {
    // pSteps.loadStep();
  }

  onSetFeatureAccessConfig() {


    //Features
    var PersonalInfo_FeaturesList = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_PersonalInfo.toUpperCase())
    var ContactInfo_FeaturesList = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_ContactInfo.toUpperCase())

    //
    var Feature_NurseProfile_ProfileSummary = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_ProfileSummary.toUpperCase())
    var Feature_NurseProfile_JobPreferences = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_JobPreferences.toUpperCase())

    var Feature_NurseProfile_Education = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Education.toUpperCase())

    var Feature_NurseProfile_EmploymentHistory = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_EmploymentHistory.toUpperCase())

    var Feature_NurseProfile_References = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_References.toUpperCase())

    var Feature_NurseProfile_Identities = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Identities.toUpperCase())
    var Feature_NurseProfile_Certifications = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Certifications.toUpperCase())

    var Feature_NurseProfile_MedicalFitness = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_MedicalFitness.toUpperCase())

    var Feature_NurseProfile_ProfileImage = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_ProfileImage.toUpperCase())

    var Feature_NurseProfile_Legalinfo = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Legalinfo.toUpperCase())


    //

    if (PersonalInfo_FeaturesList.length > 0) {
      if (PersonalInfo_FeaturesList[0].Edit === true) {
        this.CanEditProfileInfo = 1;
      }
      if (PersonalInfo_FeaturesList[0].List === true) {
        this.CanShowProfileInfo = 1;
        //this.GetActorPersonalDetailInfoController();
      }
    }
    if (ContactInfo_FeaturesList.length > 0) {
      if (ContactInfo_FeaturesList[0].Edit === true) {
        this.CanEditContactInfo = 1;
      }
      if (ContactInfo_FeaturesList[0].List === true) {
        this.CanShowContactInfo = 1;
      }
    }

    //
    if (Feature_NurseProfile_ProfileSummary.length > 0) {
      if (Feature_NurseProfile_ProfileSummary[0].Edit === true) {
        this.CanEditProfileSummary = 1;
      }
      if (Feature_NurseProfile_ProfileSummary[0].List === true) {
        this.CanShowProfileSummary = 1;
      }
    }

    if (Feature_NurseProfile_JobPreferences.length > 0) {
      if (Feature_NurseProfile_JobPreferences[0].Edit === true) {
        this.CanEditJobPreferences = 1;
      }
      if (Feature_NurseProfile_JobPreferences[0].List === true) {
        this.CanShowJobPreferences = 1;
      }
    }

    if (Feature_NurseProfile_Education.length > 0) {
      if (Feature_NurseProfile_Education[0].Edit === true) {
        this.CanEditEducation = 1;
      }
      if (Feature_NurseProfile_Education[0].List === true) {
        this.CanShowEducation = 1;
      }
    }

    if (Feature_NurseProfile_EmploymentHistory.length > 0) {
      if (Feature_NurseProfile_EmploymentHistory[0].Edit === true) {
        this.CanEditEmploymentHistory = 1;
      }
      if (Feature_NurseProfile_EmploymentHistory[0].List === true) {
        this.CanShowEmploymentHistory = 1;
      }
    }

    if (Feature_NurseProfile_References.length > 0) {
      if (Feature_NurseProfile_References[0].Edit === true) {
        this.CanEditReferences = 1;
      }
      if (Feature_NurseProfile_References[0].List === true) {
        this.CanShowReferences = 1;
      }
    }

    if (Feature_NurseProfile_Identities.length > 0) {
      if (Feature_NurseProfile_Identities[0].Edit === true) {
        this.CanEditIdentities = 1;
      }
      if (Feature_NurseProfile_Identities[0].List === true) {
        this.CanShowIdentities = 1;
      }
    }

    if (Feature_NurseProfile_Certifications.length > 0) {
      if (Feature_NurseProfile_Certifications[0].Edit === true) {
        this.CanEditCertifications = 1;
      }
      if (Feature_NurseProfile_Certifications[0].List === true) {
        this.CanShowCertifications = 1;
      }
    }

    if (Feature_NurseProfile_MedicalFitness.length > 0) {
      if (Feature_NurseProfile_MedicalFitness[0].Edit === true) {
        this.CanEditMedicalFitness = 1;
      }
      if (Feature_NurseProfile_MedicalFitness[0].List === true) {
        this.CanShowMedicalFitness = 1;
      }
    }

    if (Feature_NurseProfile_ProfileImage.length > 0) {
      if (Feature_NurseProfile_ProfileImage[0].Edit === true) {
        this.CanEditProfileImage = 1;
      }
      if (Feature_NurseProfile_ProfileImage[0].List === true) {
        this.CanShowProfileImage = 1;
      }
    }

    if (Feature_NurseProfile_Legalinfo.length > 0) {
      if (Feature_NurseProfile_Legalinfo[0].Edit === true) {
        this.CanEditLegalinfo = 1;
      }
      if (Feature_NurseProfile_Legalinfo[0].List === true) {
        this.CanShowLegalinfo = 1;
      }
    }
    this.IsSetAccessRights = true;





    //
  }
  //var PatientActorCode = this.ActorCode;


  //AddDetails() {
  //  const modalRef = this.modalService.open(NgbTcDetailsModal,
  //    {
  //      centered: true,
  //      size: "lg"
  //    })

  //}
  //AddEventDetails() {
  //  const modalRef = this.modalService.open(NgbEventAddModal,
  //    {
  //      centered: true

  //    })

  //}
  pdata: any[];// = this.data;
  listFilter: string;
  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.CurrentCycleSpermPreparationBetweenDateController;

    this.criteriaChange(this.listFilter);
  }
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        //alert(this.listFilter);
        this.pdata = this.filter.transform(this.CurrentCycleSpermPreparationBetweenDateController,
          this.listFilter);
      }
    }
  }
  //

  //

  showPage(page: string) {
    this.currentPage = page;
  }
  BackToProfile() {
    alert("method");
    this.router.navigate(['testnurse/dashboard']);

  }
  BackToTreatment() {
    alert("Thistrearment");
    this.router.navigate(['testnurse/ivfdashboard']);
  }
  onClick() {
    let x = document.querySelector("#psa");
    if (x) {
      x.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  pickUp() {
    let y = document.querySelector("#pickup");
    if (y) {
      y.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  ET() {
    let z = document.querySelector("#et");
    if (z) {
      z.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  InsuminationLog() {
    let m = document.querySelector("#IL");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  Grading() {
    let m = document.querySelector("#Grad");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  OQA() {
    let m = document.querySelector("#oqa");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  scans() {
    let m = document.querySelector("#scans");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  onpersonalInfoChange(event: any) {
    // console.log('onpersonalInfoChange');

    if (event != null) {

      this.ValueChangeActorPersonalInfoController = event;
      //console.log('this.ValueChangeActorPersonalInfoController.DisplayName--->' + this.ValueChangeActorPersonalInfoController.DisplayName);
      //this.ValueChangeActorPersonalInfoController.DisplayName = this.CurrentActorProfileController.DisplayName;
      if (this.ValueChangeActorPersonalInfoController.DisplayName != null) {
        this.CurrentActorProfileController.DisplayName = this.ValueChangeActorPersonalInfoController.DisplayName;
      }


    }

  }
  onactorImageInfoChange(event: any) {


    if (event != null) {

      this.ValueChangeActorImageController = event;

      if (this.ValueChangeActorImageController.ActorImageFileUrl != null) {
        //console.log('this.ValueChangeActorImageController.ActorImageFileUrl-->' + this.ValueChangeActorImageController.ActorImageFileUrl);

        this.CurrentActorProfileController.ActorImageFileUrl = this.ValueChangeActorImageController.ActorImageFileUrl;
      }


    }

  }
  SelectedpatientDetails: CycleSpermPreparationBetweenDateController;

  Selectedpatient(objCategory: any) {
    var Patient: CycleSpermPreparationBetweenDateController = objCategory;
    if (Patient != null) {
      this.SelectedpatientDetails = null;
      this.SelectedpatientDetails = Patient;
      this.ScanDetails = true;
      this.LoadSperm();
      this.LoadStoragedata();
      this.LoadCycles();
      this.CanLoadReport = true;
      //this.LoadScansData();
      //this.LoadOvaryData();
      //this.LoadTestData();
      //this.LoadMedicineData();
    }

  }
  CurrentSpermSourceDetailsController: SpermSourceDetailsController[];
  SpermEndInfo: SpermSourceDetailsController;
  CurrentSpermSourceDetailsRequest: SpermSourceDetailsRequest;
  LoadSperm() {
    this.CurrentSpermSourceDetailsRequest = new SpermSourceDetailsRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentSpermSourceDetailsRequest.Branch = AppData.Instance().SelectedBranchCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
    this.CurrentSpermSourceDetailsRequest.ConditionalOperator = 10;
    this.CurrentSpermSourceDetailsRequest.FromDate = new Date();
    this.CurrentSpermSourceDetailsRequest.ToDate = new Date();
    this.CurrentSpermSourceDetailsRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentSpermSourceDetailsRequest.SemanDataCode = 0;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentSpermSourceDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
    this.GetSpermSourceDetailsController();
  }

  GetSpermSourceDetailsController() {
    // this.StartRefreshing();


    this.actorservice.GetSpermSourceDetailsController(this.CurrentSpermSourceDetailsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentSpermSourceDetailsController = this.ApiResData.Result;
          this.SpermEndInfo = this.CurrentSpermSourceDetailsController[0];
          if (this.CurrentSpermSourceDetailsController.length > 0) {
            this.SpermEndInfo = this.CurrentSpermSourceDetailsController[0];
            if (this.SpermEndInfo.DateOfSampleCollection != null) {
              var SValidFrom = new Date(this.SpermEndInfo.DateOfSampleCollection);
              if (SValidFrom.getFullYear() > 1900) {
                console.log('this.UpdateDate >1990');
                this.DateofSampleCollection = {

                  year: SValidFrom.getFullYear(),
                  month: SValidFrom.getMonth() + 1,
                  day: SValidFrom.getDate()
                };

                this.ExtractionDate = {

                  year: SValidFrom.getFullYear(),
                  month: SValidFrom.getMonth() + 1,
                  day: SValidFrom.getDate()
                };
              }
            }



            //if (this.SpermEndInfo.DateOfSampleCollection != null) {
            //  var SValidFrom = new Date(this.SpermEndInfo.DateOfSampleCollection);
            //  if (SValidFrom.getFullYear() > 1900) {
            //    console.log('this.UpdateDate >1990');
            //    //this.ExtractionDate = {

            //    //  year: SValidFrom.getFullYear(),
            //    //  month: SValidFrom.getMonth() + 1,
            //    //  day: SValidFrom.getDate()
            //    //}
            //  }
            //}

            //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
            //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
            //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
            //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
            // this.stopRefreshing();
          }
          else {
            this.SpermEndInfo = new SpermSourceDetailsController();
          }
          this.LoadPatients();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentIvfSpermStoreByCodeController: IvfSpermStoreByCodeController[];
  SpermSourceInfo: IvfSpermStoreByCodeController;
  CurrentIvfSpermStoreByCodeRequest: IvfSpermStoreByCodeRequest;
  LoadStoragedata() {
    this.CurrentIvfSpermStoreByCodeRequest = new IvfSpermStoreByCodeRequest();
    this.CurrentIvfSpermStoreByCodeRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentIvfSpermStoreByCodeRequest.ActorCode = this.SelectedpatientDetails.EggSourceActorCode;
    this.CurrentIvfSpermStoreByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
    this.GetIvfSpermStoreByCodeController();
  }

  GetIvfSpermStoreByCodeController() {
    // this.StartRefreshing();


    this.actorservice.GetIvfSpermStoreByCodeController(this.CurrentIvfSpermStoreByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentIvfSpermStoreByCodeController = this.ApiResData.Result;
          if (this.CurrentIvfSpermStoreByCodeController
            != null &&
            this.CurrentIvfSpermStoreByCodeController.length == 1) {
            this.SpermSourceInfo = this.CurrentIvfSpermStoreByCodeController[0];
          }
          else {
            this.SpermSourceInfo = new IvfSpermStoreByCodeController();
            this.SpermSourceInfo.StorageUnitDetails = "";
            this.SpermSourceInfo.StorageUnitType = "";
            this.SpermSourceInfo.Volume = 0;
            this.SpermSourceInfo.VolumeUnits = "";
            this.SpermSourceInfo.SpermStoreCode = 0;





          }

          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          // this.stopRefreshing();
          //this.LoadPatients();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
  ActorCodeDetails: TreatmentCyclesByActorCodeController;
  SelectedTreatmentCycle: TreatmentCyclesByActorCodeController;

  CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
  LoadPatients() {
    this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
    this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = 0;
    this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
    this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
    this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetTreatmentCyclesByActorCodeController();
  }

  GetTreatmentCyclesByActorCodeController() {
    // this.StartRefreshing();


    this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
          this.ActorCodeDetails = this.CurrentTreatmentCyclesByActorCodeController[0];
          //this.SelectedActorCode = this.CurrentTreatmentCyclesByActorCodeController[0].EggActorCode;
          //this.SelectedTreatmentCycle = this.CurrentTreatmentCyclesByActorCodeController[0];
          //this.LMPDate = this.SelectedTreatmentCycle.LMP;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          //this.stopRefreshing();
          //this.LoadPlan();
          this.LoadDSAData();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }


  dataAcotrCode(newobj) {
    this.ActorCodeLoad();

  }
  ActorCodeLoad() {
    //alert("ActorCode");
    var SelectedActorCode = this.ActorCodeDetails.RecepientActorCode;
    return SelectedActorCode;
  }
  GetActorCode(EggSourceType: string): number {
    // alert("new");
    if (EggSourceType == 'Donor') {
      var DonorActorCode = this.ActorCodeDetails.EggActorCode;
      return DonorActorCode;
    }
    else if (EggSourceType == 'Self') {
      var OwnerActorCode = this.SelectedpatientDetails.EggSourceActorCode;
      return OwnerActorCode;
    }
  }

  CurrentDSAActivityByCycleCodeController: DSAActivityByCycleCodeController[];
  DSADetails: DSAActivityByCycleCodeController;
  CurrentDSAActivityByCycleCodeRequest: DSAActivityByCycleCodeRequest;

  LoadDSAData() {
    //alert("ScansData")
    this.CurrentDSAActivityByCycleCodeRequest = new DSAActivityByCycleCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentDSAActivityByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDSAActivityByCycleCodeController();
  }

  GetDSAActivityByCycleCodeController() {
    //this.StartRefreshing();

    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentDSAActivityByCycleCodeRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentDSAActivityByCycleCodeRequest.ConditionalOperator = 10;
    this.CurrentDSAActivityByCycleCodeRequest.ActorCode = this.GetActorCode(this.SelectedpatientDetails.EggSourceType);
    //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    // this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
    //alert(this.FormattedCode);
    this.actorservice.GetDSAActivityByCycleCodeController(this.CurrentDSAActivityByCycleCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentDSAActivityByCycleCodeController = this.ApiResData.Result;
          this.DSADetails = this.GetCycleActivity(this.GetActorCode(this.SelectedpatientDetails.EggSourceType), this.SelectedpatientDetails.ProtocolStartDate)[0];
          //alert(this.DSADetails);
          //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
          //this.Antag = this.GetCycleActivity(ActorCode, Date)[0].ANTAG;
          //this.Stimulation = this.GetCycleActivity(ActorCode, Date)[0].STIMULATION;

          //  this.GetDsADetails(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate);
          //var list = this.CurrentDSAActivityByCycleCodeController.filter(


          //    function (a) {
          //        var Date = this.FollicularScanEndInfo.ScanDate;
          //        var ActorCode = this.SelectedpatientDetails.ActorID;
          //        return a.ActivityDate == Date && a.ActorCode == ActorCode
          //    });

          //this.CurrentDSAActivityByCycleCodeController = list;
          //alert(this.CurrentDSAActivityByCycleCodeController[0].DOC);
          //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
          //this.Antag = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].ANTAG;
          //this.Stimulation = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].STIMULATION;
          //alert(this.Doc1);
          //alert(this.Antag);
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  //    GetDsADetails(ActorCode: number, Date: Date) {


  //}
  GetCycleActivity(ReceipientActorCode: number, TransferDateNew: Date): DSAActivityByCycleCodeController[] {
    //alert(ReceipientActorCode);
    //alert(TransferDateNew);
    return this.CurrentDSAActivityByCycleCodeController.filter(
      function (v, i, d) {

        return v.ActorCode == ReceipientActorCode && v.ActivityDate == TransferDateNew;
      }
    )

  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  closeResult: string;
  // This function is used in open
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  // Open content with dark section
  //openContent() {
  //  alert('open dialog');
  //  if (this.CurrentActorProfileController.ActorImageCode != null && this.CurrentActorProfileController.ActorImageCode > 0) {
  //    const modalRef = this.modalService.open(NgbdUploadActorImageModal, {
  //      centered: true
  //    })
  //    modalRef.componentInstance.ActorImageCode = this.CurrentActorProfileController.ActorImageCode;
  //    modalRef.componentInstance.ActorCode = this.CurrentActorProfileController.ActorCode;
  //    modalRef.componentInstance.ActorImageFile == this.CurrentActorProfileController.ActorImageFile;
  //    modalRef.componentInstance.ActorImageFileExtension = this.CurrentActorProfileController.ActorImageFileExtension;

  //    modalRef.result.then(x => { this.GetActorProfileController() })

  //  }
  //  else {
  //    alertFunctions.AlertParam('you dont have Permission to Upload...!');
  //  }
  //}
  //Selectedpatient() {

  //}
  BackTodashboard() {
    //this.Showivf = true;
    //this.ShowSemen = false;
    this.router.navigate(['healins/ivfworkbench']);
  }
  SelectedValue: string;
  SelectedSource: string;
  patientName: string;
  PatientFomratted: string;
  patientActorCode: number;

  SelectDonorForEgg() {
    const modalRef = this.modalService.open(NgbSearchDonarModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.patientName = receivedEntry.make;
      this.PatientFomratted = receivedEntry.value;
      this.patientActorCode = receivedEntry.key2;
      //alert(this.Code);
    })
  }
  onChange(event: any) {

    this.SelectedValue = event;
    //if (this.SelectedValue == "Fresh") {
    //  this.CurrentSaveSpermDetailsRequest.SpermSourceCode = this.SpermEndInfo.OwnerActorCode;
    //  this.CurrentSaveSpermDetailsRequest.SpermSourceFormattedCode = this.SpermEndInfo.OwnerFormattedCode;
    //}
    //else {
    //  this.CurrentSaveSpermDetailsRequest.SpermSourceCode = this.patientActorCode;
    //  this.CurrentSaveSpermDetailsRequest.SpermSourceFormattedCode = this.PatientFomratted;
    //}
    //alert(this.SelectedValue);
    // ... do other stuff here ...
  }
  onChange2(event: any) {
    this.SelectedSource = event;
  }
  dataChanged(newobj) {

    this._GetCycleSpermPreparationBetweenDateController();
  }
  _GetCycleSpermPreparationBetweenDateController() {
    this.StartRefreshing();
    this.CurrentCycleSpermPreparationBetweenDateRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentCycleSpermPreparationBetweenDateRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));;

    this.actorservice.GetCycleSpermPreparationBetweenDateController(this.CurrentCycleSpermPreparationBetweenDateRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentCycleSpermPreparationBetweenDateController = this.ApiResData.Result;
          this.pdata = this.CurrentCycleSpermPreparationBetweenDateController;

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  DecrementDate() {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetCycleSpermPreparationBetweenDateController();
    //ind++;
  }
  IncrementDate() {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetCycleSpermPreparationBetweenDateController();
    //ind++;
  }

  onSubmit() {

    this.spinner.show();
    this.CurrentSaveSpermDetailsRequest.ConditionalOperator = 10;
    this.CurrentSaveSpermDetailsRequest.SpermSource = this.SpermEndInfo.SpermSource;
    if (this.CurrentSaveSpermDetailsRequest.SpermSource == "Fresh") {
      this.CurrentSaveSpermDetailsRequest.SpermSourceCode = this.SpermEndInfo.OwnerActorCode;
      this.CurrentSaveSpermDetailsRequest.SpermSourceFormattedCode = this.SpermEndInfo.OwnerFormattedCode;
    }
    else {
      this.CurrentSaveSpermDetailsRequest.SpermSourceFormattedCode = this.PatientFomratted;
      this.CurrentSaveSpermDetailsRequest.SpermSourceCode = this.patientActorCode;
    }
    this.CurrentSaveSpermDetailsRequest.SpermSourceFrom = this.SpermEndInfo.SpermSourceFrom;
    this.CurrentSaveSpermDetailsRequest.StorageLocationDetails = this.SpermEndInfo.StorageLocationDetails;
    this.CurrentSaveSpermDetailsRequest.SpermRetrieval = this.SpermEndInfo.SpermRetrieval;
    this.CurrentSaveSpermDetailsRequest.ExtractionDate = new Date(this.parserFormatter.format(this.ExtractionDate));
    //this.CurrentSaveSpermDetailsRequest.ExtractionTime = Date.now();
    this.CurrentSaveSpermDetailsRequest.ExtractionTime = new Date();
    this.CurrentSaveSpermDetailsRequest.TreatmentCycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CurrentSaveSpermDetailsRequest.SpermSourceCode = this.patientActorCode;
    //if (this.CurrentSaveSpermDetailsRequest.SpermSourceCode = 0) {
    //  this.CurrentSaveSpermDetailsRequest.SpermSourceCode =0;
    //}
    //this.CurrentSaveSpermDetailsRequest.SpermSourceFormattedCode = this.PatientFomratted;
    //if (this.CurrentSaveSpermDetailsRequest.SpermSourceFormattedCode = "null") {
    //  this.CurrentSaveSpermDetailsRequest.SpermSourceFormattedCode = this.SpermEndInfo.OwnerFormattedCode;
    //}
    this.CurrentSaveSpermDetailsRequest.HasICSI = false;
    this.CurrentSaveSpermDetailsRequest.HASIMSI = false;
    this.CurrentSaveSpermDetailsRequest.hasIVF = false;
    this.CurrentSaveSpermDetailsRequest.ICSIDetails = "";
    this.CurrentSaveSpermDetailsRequest.ICSIPerformedBy = 0;
    this.CurrentSaveSpermDetailsRequest.ICSIPerformedByName = "";
    this.CurrentSaveSpermDetailsRequest.IMSIDetails = "";
    this.CurrentSaveSpermDetailsRequest.IMSIPerformedBy = 0;;
    this.CurrentSaveSpermDetailsRequest.IMSIPerformedByName = "";
    this.CurrentSaveSpermDetailsRequest.IVFDetails = "";
    this.CurrentSaveSpermDetailsRequest.IVFPerformedBy = 0;
    this.CurrentSaveSpermDetailsRequest.Remarks = "";
    this.CurrentSaveSpermDetailsRequest.IVFPerformedByName = "";
    this.CurrentSaveSpermDetailsRequest.Remarks2 = "";
    this.CurrentSaveSpermDetailsRequest.Remarks3 = "";
    this.CurrentSaveSpermDetailsRequest.CycleOocyteQualityCode = 0;
    //this.CurrentSaveSpermDetailsRequest.ExtractionTime = "10:00";
    this.actorservice.SaveSpermDetails(this.CurrentSaveSpermDetailsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.spinner.hide();
            //this.activeModal.close();
            //this.clearData();
            // this.LoadScansData();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.spinner.hide();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.spinner.hide();
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );


  }
  onSubmit2() {
    this.spinner.show();
    this.CurrentSaveSemenDataRequest.ConditionalOperator = 1;
    this.CurrentSaveSemenDataRequest.DateofSampleCollection = new Date(this.parserFormatter.format(this.DateofSampleCollection));
    this.CurrentSaveSemenDataRequest.TimeofSampleCollection = this.SpermEndInfo.TimeOFSampleCollection;
    this.CurrentSaveSemenDataRequest.Volume = this.SpermEndInfo.Volume;
    this.CurrentSaveSemenDataRequest.Count = this.SpermEndInfo.Count;
    this.CurrentSaveSemenDataRequest.MotileSpermMotility = this.SpermEndInfo.MotileSpermMotility;
    this.CurrentSaveSemenDataRequest.ActiveProgressiveMotility = this.SpermEndInfo.ActiveProgressiveMotility;
    this.CurrentSaveSemenDataRequest.CellularDebris = this.SpermEndInfo.CellularDebris;
    this.CurrentSaveSemenDataRequest.MethodofPreparation = this.SpermEndInfo.MethodOfPreparation;
    this.CurrentSaveSemenDataRequest.IncubationTime = this.SpermEndInfo.IncubationTime;
    this.CurrentSaveSemenDataRequest.MotileSpermCount = this.SpermEndInfo.MotileSpermCount;
    this.CurrentSaveSemenDataRequest.Motility = this.SpermEndInfo.Motility;
    this.CurrentSaveSemenDataRequest.Notes = this.SpermEndInfo.Notes;
    this.CurrentSaveSemenDataRequest.SlideObserved = this.SpermEndInfo.SlideObserved;
    this.CurrentSaveSemenDataRequest.CatheterLoadDate = new Date(this.parserFormatter.format(this.DateofSampleCollection));
    this.CurrentSaveSemenDataRequest.CatheterLoadedBy = this.SpermEndInfo.CatheterLoadedBy;
    this.CurrentSaveSemenDataRequest.CatheterLoadedByName = this.SpermEndInfo.CatheterLoadedByName;
    this.CurrentSaveSemenDataRequest.CatheterLoadTime = new Date();
    this.CurrentSaveSemenDataRequest.Day = 1;
    this.CurrentSaveSemenDataRequest.DFI = this.SpermEndInfo.DFI;
    this.CurrentSaveSemenDataRequest.ProgressiveMotility = this.SpermEndInfo.ProgressiveMotility;
    this.CurrentSaveSemenDataRequest.Morphology = this.SpermEndInfo.Morphology;
    this.CurrentSaveSemenDataRequest.NonProgressiveMotility = this.SpermEndInfo.NonProgressiveMotility;
    this.CurrentSaveSemenDataRequest.IterationType = "Pre-Wash";
    this.CurrentSaveSemenDataRequest.PreparedBy = this.SpermEndInfo.PreparedBy;
    this.CurrentSaveSemenDataRequest.PreparedByName = this.SpermEndInfo.PreparedByName;
    this.CurrentSaveSemenDataRequest.ReadyForInsemination = this.SpermEndInfo.ReadyForInsemination;
    this.CurrentSaveSemenDataRequest.SampleType = this.SpermEndInfo.SampleType;
    this.CurrentSaveSemenDataRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;

    this.CurrentSaveSemenDataRequest.SlideObservedBy = this.SpermEndInfo.SlideObservedBy;
    this.CurrentSaveSemenDataRequest.SlideObservedByName = this.SpermEndInfo.SlideObservedByName;


    this.actorservice.SaveSemenData(this.CurrentSaveSemenDataRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.spinner.hide();
            //this.activeModal.close();
            //this.clearData();
            // this.LoadScansData();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.spinner.hide();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.spinner.hide();
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );


  }
  onSubmitStore() {
    this.spinner.show();
    if (this.SpermSourceInfo.SpermStoreCode == 0) {
      this.CurrentSaveIvfSpermStoreRequest.ConditionalOperator = 10;

    }
    else {
      this.CurrentSaveIvfSpermStoreRequest.ConditionalOperator = 20;
    }
    //this.CurrentSaveIvfSpermStoreRequest.ConditionalOperator = 10;
    this.CurrentSaveIvfSpermStoreRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentSaveIvfSpermStoreRequest.CreatedUser = AppData.Instance().UserLoginDetails.UserName;
    this.CurrentSaveIvfSpermStoreRequest.LastUpdateDate = new Date();
    this.CurrentSaveIvfSpermStoreRequest.LastUpdateTime = new Date();
    this.CurrentSaveIvfSpermStoreRequest.Status = "";
    this.CurrentSaveIvfSpermStoreRequest.ActorCode = this.SelectedpatientDetails.EggSourceActorCode;
    this.CurrentSaveIvfSpermStoreRequest.SpermStoreCode = this.SpermSourceInfo.SpermStoreCode;
    this.CurrentSaveIvfSpermStoreRequest.StorageUnitDetails = this.SpermSourceInfo.StorageUnitDetails;
    this.CurrentSaveIvfSpermStoreRequest.Volume = this.SpermSourceInfo.Volume;
    this.CurrentSaveIvfSpermStoreRequest.VolumeUnits = this.SpermSourceInfo.VolumeUnits;
    this.CurrentSaveIvfSpermStoreRequest.StorageUnitType = this.SpermSourceInfo.StorageUnitType;

    this.actorservice.SaveIvfSpermStore(this.CurrentSaveIvfSpermStoreRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.spinner.hide();
            //this.activeModal.close();
            //this.clearData();
            // this.LoadScansData();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.spinner.hide();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.spinner.hide();
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );


  }
  SemenAnalysis() {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {

      this.SemenAnalysisCompleted();

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Saving Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  SemenAnalysisCompleted() {


    console.log('..................');
    //this.StartRefreshing();
    if (this.SelectedpatientDetails.CycleType !== 'IUI') {
      this.CurrentSaveCycleStatusRequest.ConditionalOperator = 40;
    }

    if (this.SelectedpatientDetails.CycleType == 'IUI') {
      this.CurrentSaveCycleStatusRequest.ConditionalOperator = 170;
    }

    this.CurrentSaveCycleStatusRequest.TreatmentCycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    this.CurrentSaveCycleStatusRequest.ActivityName = "Semen Analysis";
    this.CurrentSaveCycleStatusRequest.ActivityStatus = "Completed";
    this.CurrentSaveCycleStatusRequest.Remarks = "None";
    //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
    //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;


    //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.actorservice.SaveCycleStatus(this.CurrentSaveCycleStatusRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.LoadCycles();
            //this.LoadScansData();
            //this.LoadOvaryData();
            //this.LoadTestData();
            //this.LoadMedicineData();
            //this.ShowList = true;
            //this.LoadMedicineData();

            //this.stopRefreshing();

          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  SemenAnalysisIUI() {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {

      this.SemenAnalysisIUICompleted();

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Saving Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  SemenAnalysisIUICompleted() {


    console.log('..................');
    //this.StartRefreshing();

    this.CurrentSaveSemenDataRequest.ConditionalOperator = 2;
    this.CurrentSaveSemenDataRequest.DateofSampleCollection = new Date(this.parserFormatter.format(this.DateofSampleCollection));
    this.CurrentSaveSemenDataRequest.TimeofSampleCollection = this.SpermEndInfo.TimeOFSampleCollection;
    this.CurrentSaveSemenDataRequest.Volume = 0;
    this.CurrentSaveSemenDataRequest.Count = 0;
    this.CurrentSaveSemenDataRequest.MotileSpermMotility = 0;
    this.CurrentSaveSemenDataRequest.ActiveProgressiveMotility = 0;
    this.CurrentSaveSemenDataRequest.CellularDebris = "";
    this.CurrentSaveSemenDataRequest.MethodofPreparation = "";
    this.CurrentSaveSemenDataRequest.IncubationTime = 0;
    this.CurrentSaveSemenDataRequest.MotileSpermCount = 0;
    this.CurrentSaveSemenDataRequest.Motility = 0;
    this.CurrentSaveSemenDataRequest.Notes = "";
    this.CurrentSaveSemenDataRequest.SlideObserved = false;
    this.CurrentSaveSemenDataRequest.CatheterLoadDate = new Date(this.parserFormatter.format(this.DateofSampleCollection));
    this.CurrentSaveSemenDataRequest.CatheterLoadedBy = 0;
    this.CurrentSaveSemenDataRequest.CatheterLoadedByName = "";
    this.CurrentSaveSemenDataRequest.CatheterLoadTime = new Date();
    this.CurrentSaveSemenDataRequest.Day = 1;
    this.CurrentSaveSemenDataRequest.DFI = "";
    this.CurrentSaveSemenDataRequest.ProgressiveMotility = "";
    this.CurrentSaveSemenDataRequest.Morphology = "";
    this.CurrentSaveSemenDataRequest.NonProgressiveMotility = "";
    this.CurrentSaveSemenDataRequest.IterationType = "";
    this.CurrentSaveSemenDataRequest.PreparedBy = 0;
    this.CurrentSaveSemenDataRequest.PreparedByName = "";
    this.CurrentSaveSemenDataRequest.ReadyForInsemination = true;
    this.CurrentSaveSemenDataRequest.SampleType = "";
    this.CurrentSaveSemenDataRequest.TreatmentCycle = this.CycleCode;

    this.CurrentSaveSemenDataRequest.SlideObservedBy = 0;
    this.CurrentSaveSemenDataRequest.SlideObservedByName = "";




    //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.actorservice.SaveSemenData(this.CurrentSaveSemenDataRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            //  this.LoadCycles();
            //this.LoadScansData();
            //this.LoadOvaryData();
            //this.LoadTestData();
            //this.LoadMedicineData();
            //this.ShowList = true;
            //this.LoadMedicineData();

            //this.stopRefreshing();

          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }

  CurrentTreatmentCycleStatusController: TreatmentCycleStatusController[];
  SemanAnalysis: TreatmentCycleStatusController[];
  SemanAnalysis2: TreatmentCycleStatusController;
  CurrentTreatmentCycleStatusRequest: TreatmentCycleStatusRequest;
  LoadCycles() {
    this.CurrentTreatmentCycleStatusRequest = new TreatmentCycleStatusRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentTreatmentCycleStatusRequest.TreatmentCycleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;

    //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentTreatmentCycleStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
    this.GetTreatmentCycleStatusController();
  }

  GetTreatmentCycleStatusController() {
    //this.StartRefreshing();
    //this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();

    this.actorservice.GetTreatmentCycleStatusController(this.CurrentTreatmentCycleStatusRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCycleStatusController = this.ApiResData.Result;
          this.SemanAnalysis = this.ApiResData.Result;
          var Semanlist = this.SemanAnalysis.filter(
            function (a) {
              return a.PhaseActivity == "Semen Analysis";
            });
          this.SemanAnalysis = Semanlist;
          this.SemanAnalysis2 = this.SemanAnalysis[0];
          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          //this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }


  printsource() {
    this.printService.printDocument("spermsourcedetails",
      {
        Owner: this.SelectedpatientDetails.OwnerName, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientId: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, CycleNo: this.SelectedpatientDetails.CycleNo, CycleType: this.SelectedpatientDetails.CycleType, Protocol: this.SelectedpatientDetails.ProtocolName,
        TreatmentCycleCodedata: this.SelectedpatientDetails.TreatmentCycleCode, TotalOocytes: this.SelectedpatientDetails.TotalOocytes, ProtocolStart: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEnd: this.SelectedpatientDetails.ProtocolEndDate,
        MaleSource: this.SpermEndInfo.SpermSource, SourceFrom: this.SpermEndInfo.SpermSourceFrom, ExtDate: this.SpermEndInfo.DateOfSampleCollection, ExtTime: this.SpermEndInfo.TimeOFSampleCollection, StorageLoc: this.SpermEndInfo.StorageLocationDetails, Technique: this.SpermEndInfo.SpermRetrieval,
        DateofsampleCollection: this.SpermEndInfo.DateOfSampleCollection, TimeofsampleCollection: this.SpermEndInfo.TimeOFSampleCollection, Volume: this.SpermEndInfo.Volume, Count: this.SpermEndInfo.Count, MotileSpermMotility: this.SpermEndInfo.MotileSpermMotility, ActiveProgressivemotility: this.SpermEndInfo.ActiveProgressiveMotility, CellularDebris: this.SpermEndInfo.CellularDebris, MethodofPreparation: this.SpermEndInfo.MethodOfPreparation,
        IncubationTime: this.SpermEndInfo.IncubationTime, MotileSpermCount: this.SpermEndInfo.MotileSpermCount, Motility: this.SpermEndInfo.Motility, Notes: this.SpermEndInfo.Notes, SlideObserved: this.SpermEndInfo.SlideObserved,
        StorageDetails: this.SpermSourceInfo.StorageUnitDetails, StorageType: this.SpermSourceInfo.StorageUnitType, StorageVolume: this.SpermSourceInfo.Volume, StorageVolumeunits: this.SpermSourceInfo.VolumeUnits,
        DSADOC: this.DSADetails.DOC, DSASTIMULATION: this.DSADetails.STIMULATION, DSAANTAG: this.DSADetails.ANTAG,
      }
    );
  }
  printsourcedroplet() {
    this.printService.printDocument2(this.SelectedpatientDetails.OwnerFormattedCode, 0

    );
    this.printService.printDocument("spermsourcedetailsdroplet",
      {
        Owner: this.SelectedpatientDetails.OwnerName, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientId: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, CycleNo: this.SelectedpatientDetails.CycleNo, CycleType: this.SelectedpatientDetails.CycleType, Protocol: this.SelectedpatientDetails.ProtocolName,
        TreatmentCycleCodedata: this.SelectedpatientDetails.TreatmentCycleCode, TotalOocytes: this.SelectedpatientDetails.TotalOocytes, ProtocolStart: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEnd: this.SelectedpatientDetails.ProtocolEndDate,
        MaleSource: this.SpermEndInfo.SpermSource, SourceFrom: this.SpermEndInfo.SpermSourceFrom, ExtDate: this.SpermEndInfo.DateOfSampleCollection, ExtTime: this.SpermEndInfo.TimeOFSampleCollection, StorageLoc: this.SpermEndInfo.StorageLocationDetails, Technique: this.SpermEndInfo.SpermRetrieval,
        DateofsampleCollection: this.SpermEndInfo.DateOfSampleCollection, TimeofsampleCollection: this.SpermEndInfo.TimeOFSampleCollection, Volume: this.SpermEndInfo.Volume, Count: this.SpermEndInfo.Count, TotalMotility: this.SpermEndInfo.ActiveProgressiveMotility, ActiveProgressivemotility: this.SpermEndInfo.ActiveProgressiveMotility, CellularDebris: this.SpermEndInfo.CellularDebris, MethodofPreparation: this.SpermEndInfo.MethodOfPreparation,
        IncubationTime: this.SpermEndInfo.IncubationTime, MotileSpermCount: this.SpermEndInfo.MotileSpermCount, Motility: this.SpermEndInfo.Motility, Notes: this.SpermEndInfo.Notes, SlideObserved: this.SpermEndInfo.SlideObserved,
        ProgressiveMotility: this.SpermEndInfo.ProgressiveMotility, Morphology: this.SpermEndInfo.Morphology, NonProgressiveMotility: this.SpermEndInfo.NonProgressiveMotility, DFI: this.SpermEndInfo.DFI,
        StorageDetails: this.SpermSourceInfo.StorageUnitDetails, StorageType: this.SpermSourceInfo.StorageUnitType, StorageVolume: this.SpermSourceInfo.Volume, StorageVolumeunits: this.SpermSourceInfo.VolumeUnits,
        EggSourceData: this.ActorCodeDetails.EggSourceType, DonorData: this.ActorCodeDetails.EggName, DonorCode: this.ActorCodeDetails.EggFormattedCode, DSADOC: this.DSADetails.DOC, DSASTIMULATION: this.DSADetails.STIMULATION, DSAANTAG: this.DSADetails.ANTAG, Immotile: this.SpermEndInfo.Immotile,
      }
    );
  }

}

